/**
 * Whether an error is a benign, deliberate fetch abort that should NOT be
 * captured by Sentry.
 *
 * `AbortError` is raised whenever an in-flight `fetch` is cancelled on purpose —
 * a component unmounting mid-request, a refetch superseding an older one, a
 * timeout handled elsewhere. It is never an actionable production error, yet a
 * cancelled fetch can surface as an unhandled rejection during React's mass
 * unmount (see Sentry LUMEN-44) despite per-site `signal.aborted` guards. This
 * is the single boundary filter for that whole class.
 */
export function isBenignAbortError(value: unknown): boolean {
  if (value instanceof DOMException) {
    return value.name === 'AbortError';
  }
  if (value instanceof Error) {
    return value.name === 'AbortError' || value.message === 'signal is aborted without reason';
  }
  return false;
}
